var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 12a9 9 0 11-6.219-8.56"}));
}

Loader.defaultProps = {"width":"100%","height":"100%","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Loader;

Loader.default = Loader;
